import Spinner from "@/components/ui/spinner";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import type { TAvatar } from "@/types/TAvatar";
import { useProgressiveImage } from "@/hooks/useProgressiveImage";

interface AvatarDisplayProps {
  isStreamReady: boolean;
  isLoadingSession: boolean;
  selectedAvatar?: TAvatar;
  attachVideo: (element: HTMLMediaElement | null) => void;
}

function AvatarDisplay({ isStreamReady, isLoadingSession, selectedAvatar, attachVideo }: AvatarDisplayProps) {
  const { t } = useTranslation();

  const { imgSrc, isHighResLoaded } = useProgressiveImage({
    lowResUrl: selectedAvatar?.preview_low_res_image_url,
    highResUrl: selectedAvatar?.preview_image_url
  });

  if (isStreamReady) {
    return (
      <video
        autoPlay
        playsInline
        className="h-full w-full object-contain"
        ref={(videoElem) => {
          attachVideo(videoElem);
        }}
      >
        <track kind="captions" />
      </video>
    );
  }
  if (isLoadingSession) {
    return (
      <div className="flex h-full w-full items-center justify-center rounded-lg object-contain">
        <Spinner text={t("common.avatarLoading")} />
      </div>
    );
  }

  if (selectedAvatar?.avatar_id && imgSrc) {
    return (
      <img
        alt={selectedAvatar.avatar_name}
        src={imgSrc}
        data-fullsrc={selectedAvatar.preview_image_url}
        className={`opacity-50 aspect-video w-full object-contain ${!isHighResLoaded && selectedAvatar.preview_low_res_image_url ? "blur-sm opacity-70 transition-all" : ""}`}
      />
    );
  }

  return null;
}

export default memo(AvatarDisplay);
